// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import IdInfoSvg from '@rsuite/icon-font/lib/people/IdInfo';
var IdInfo = createSvgIcon({
  as: IdInfoSvg,
  ariaLabel: 'id info',
  category: 'people',
  displayName: 'IdInfo'
});
export default IdInfo;